import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnChanges, OnInit, Optional, ViewChild, input, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { faEdit, faTrash, faCommentSlash, faMessage, faFileArrowDown, faFilePen, faCheck } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ViewportScroller } from '@angular/common';
import { Subject } from 'rxjs';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'
const pdfMakeX: any = pdfMake;
const pdfFontsX: any = pdfFonts;
pdfMakeX.vfs = pdfFontsX.vfs;
import htmlToPdfMake from 'html-to-pdfmake';

@Component({
  selector: 'print-report-accomplishment',
  templateUrl: './print-report-accomplishment.component.html',
  styleUrls: ['./print-report-accomplishment.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class PrintReportAccomplishmentComponent implements OnInit {
  //icons
  faEdit = faEdit;
  faTrash = faTrash;
  faCommentSlash = faCommentSlash;
  faFileArrowDown = faFileArrowDown;
  faMessage = faMessage;
  faFile = faFilePen;
  faCheck = faCheck;

  report: any;
  reportList: any;
  report_status: any;
  complete: boolean = false;
  nav = signal<string>('');
  current_status: number | undefined = undefined;
  autosave: any = { saving: false, saved: false, saveTime: new Date(), updateTimer: new Subject() };
  reportSections: any;

  currentUser: any;
  is_co: boolean = false;
  scroll_id: number = -1;

  @ViewChild('printContainer') reportPDF!: ElementRef;
  loaded = [false, false, false]

  pageNames = [
    "Fire Report Details",
    "Authorized & Completed Treatments",
    "Additional Information"
  ]

  treatmentTypes = [
    { treatment_type_id: 2, treatment_type: 'Channel' },
    { treatment_type_id: 1, treatment_type: 'Ground Cover' },
    { treatment_type_id: 3, treatment_type: 'Heritage' },
    { treatment_type_id: 7, treatment_type: 'Monitoring' },
    { treatment_type_id: 0, treatment_type: 'Plants' },
    { treatment_type_id: 4, treatment_type: 'Roads' },
    { treatment_type_id: 6, treatment_type: 'Safety' },
    { treatment_type_id: 5, treatment_type: 'Trails' },
    { treatment_type_id: 8, treatment_type: 'Total' }
  ]

  maxPage = 3

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly reportService: ReportService,
    private readonly accomplishmentService: AccomplishmentService,
    private readonly userService: UserService,
    private readonly dialogService: DialogService,
    private readonly viewportScroller: ViewportScroller,
    public readonly dialogRef: MatDialogRef<PrintReportAccomplishmentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.reportSections = this.reportService.getReportPageList();
  }

  ngOnInit(): void {
    this.dialogService.openSpinner();
    let relations: string;
    relations = '&relations=accomplishment_treatments.forest_treatment,additional_reports';
    this.accomplishmentService.getAccomplishment(this.data.accomplishment_id, relations).subscribe((report: any) => {
      this.report = report.accomplishments[0];
      this.setReportStatus();
      this.nav.set('');
      const reportRelations = '&relations=assessment,forests.treatments.treatment_specifications,forests.treatments.treatment_option,forests.treatments.treatment_type';
      this.reportService.getReportList(this.report.assessment_id, reportRelations).subscribe((reports: any) => {
        let reportList = reports.reports.filter((report: any) => (report.authorization_status_id == 4 || report.authorization_status_id == 6)); //ignore pre-assessment and not funding auth
        reportList = reportList.sort((reportA: any, reportB: any) => reportB.report_id - reportA.report_id);
        this.reportList = reportList;
      })
    })
    this.userService.getUserProfile().then((user) => {
      this.currentUser = user;
    })
  }

  subLoaded(page: any) {
    this.loaded[page - 1] = true;
    const allLoaded = this.loaded.reduce((acc, val) => acc && val, true);
    if (allLoaded) {
      setTimeout(() => {
        this.exportPDF();
        this.dialogService.closeSpinner();
        this.dialogRef.close();
      }, 1000);
    }
  }

  statusChange(status: any) {
    this.current_status = status;
    this.setReportStatus();
    const filtered_status = this.report_status.filter((status: any) => status.status < 2)
    if (filtered_status.length >= 1) {
      this.complete = false;
    } else this.complete = true;
  }

  setReportStatus() {
    let status_3 = this.report.page_3_status_id;
    this.report_status = [
      { report_page: 1, status: this.report.page_1_status_id },
      { report_page: 2, status: this.report.page_2_status_id },
      { report_page: 3, status: status_3 }
    ]
  }

  exportPDF() {
    pdfMake.fonts = {
      'Roboto': {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    }
    const reportPDF = this.reportPDF.nativeElement.innerHTML;
    let start = "<fa-icon";
    let end = "</fa-icon>";
    // Create a regular expression to match the content between the start and end
    const regex = new RegExp(`(?<=${start}).*?(?=${end})`, 'g');

    start = 'class="user-icon">'
    end = '</div>'
    const regex2 = new RegExp(`(?<=${start}).*?(?=${end})`, 'g');
    const cleanedtext = reportPDF.replaceAll(regex, '').replaceAll(regex2, '</div>').replaceAll('keyboard_arrow_down', '').replaceAll('chevron_right', '').replaceAll('>location_on<', '>location: <').replaceAll('>email<', '>email: <').replaceAll('>phone<', '>phone: <').replaceAll('info_outline','').replaceAll('View full size image','').replaceAll('Sign & Certified','')
    let margin0: [number,number,number,number] = [0,0,0,10]
    let margin1: [number,number,number,number] = [0,0,0,0]
    const options = {
      defaultStyles: {
        h1: { fontSize: 16, bold: true, marginBottom: 10 },
        h2: { fontSize: 14, bold: true, marginBottom: 10 },
        h3: { fontSize: 12, bold: true, marginBottom: 10 },
        p: { margin: margin0},
        b: { marginTop: 10, paddingTop: 10},
        div: {margin: margin1}
      }
    };

    const html = htmlToPdfMake(cleanedtext, options);
    const styles = {
      "title": {
        "bold": "true",
        "fontSize": "14",
        "margin": [0, 10, 0, 0]
      },
      "data-title": {
        "bold": "true",
        "fontSize": "12"
      },
      "form-header": {
        "fontSize": "14",
        "margin": [0, 10, 0, 0]
      },
      "html-b": {
        "margin": [0, 10, 0, 0],
        "fontSize": "12"
      },
      "user-name": {
        "color": "black",
        "decoration": [],
        "margin": [0, 10, 0, 0],
        "bold": "true",
        "fontSize": "14"
      },
      "report-section": {
        "margin": [0, 10, 0, 0]
      },
      "site-page-title": {
        "fontSize": "14"
      }
    }
    const docDefinition: any = { content: html, styles: styles };
    const pdfName = this.report.report_name + '.pdf';
    pdfMake.createPdf(docDefinition).download(pdfName);
  }
}
